import { CheckIcon, UsersRoundIcon } from "lucide-react";
import SvgNewsLetterAndCommunity from "components/common/iconComponents/newsLetterAndCommunityIcon";
import SvgEmailOutreachIcon from "components/common/iconComponents/emailOutreachIcon";
import SvgLetterOutreach from "components/common/iconComponents/letterOutreach";
import SvgDomainIcon from "components/common/iconComponents/domainIcon";
import SvgDealTracker from "components/common/iconComponents/dealTracker";
import SvgMailBoxIcon from "components/common/iconComponents/mailboxIcon";
import SvgSearchCollectionIcon from "components/common/iconComponents/searchCollectionIcon";
import SvgSearchIconSubscription from "components/common/iconComponents/searchIconSubscription";
import { FEATURE_NAME, LOOKUP_KEY, SUBSCRIPTION_PLAN_NAME } from "./types";
import SvgListCheckIcon from "components/common/iconComponents/listCheckIcon";
import SvgSearchIcon from "components/common/iconComponents/searchIcon";
import SvgTelescopeIcon from "components/common/iconComponents/teleScopeIcon";
import SvgTeamIconSubscription from "components/common/iconComponents/teamIconSubscription";

interface FeatureIconProps {
  lookupKey: string;
  isHarbour: boolean;
}

interface AdditionalFeatureIconProps {
  featureName: string;
  isHarbour: boolean;
}

interface PlanIconProps {
  planName: string;
  isHarbour: boolean;
}

export const renderFeatureIcon = ({
  lookupKey,
  isHarbour,
}: FeatureIconProps) => {
  switch (lookupKey) {
    case LOOKUP_KEY.SEARCH:
      return (
        <SvgSearchCollectionIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case LOOKUP_KEY.COLLECTION:
      return (
        <SvgSearchCollectionIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case LOOKUP_KEY.EMAIL_OUTREACH:
      return (
        <SvgEmailOutreachIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case LOOKUP_KEY.LETTER_OUTREACH:
      return (
        <SvgLetterOutreach
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case LOOKUP_KEY.TEAM_MEMBERS:
      return (
        <UsersRoundIcon
          stroke={isHarbour ? "#0BA5EC" : "#F63D68"}
          className="h-6 w-6 text-gray-600"
        />
      );

    case LOOKUP_KEY.SELLER_VERIFIED_LISTINGS:
      return (
        <SvgListCheckIcon
          className="h-6 w-6 text-gray-600"
          isHarbour={isHarbour}
        />
      );
    case LOOKUP_KEY.UNLIMITED_SEARCH:
      return (
        <SvgSearchIcon
          className="h-6 w-6 text-gray-600"
          isHarbour={isHarbour}
        />
      );
    case LOOKUP_KEY.DEAL_TRACKER:
      return (
        <SvgDealTracker
          isHarbour={isHarbour}
          className="h-6 w-6 text-gray-600"
        />
      );
    case LOOKUP_KEY.COMMUNITY_AND_NEWSLETTER:
      return (
        <SvgNewsLetterAndCommunity
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    default:
      return null;
  }
};

export const renderAdditionalFeatureIcon = ({
  featureName,
  isHarbour,
}: AdditionalFeatureIconProps) => {
  switch (featureName) {
    case FEATURE_NAME.COMMUNITY_AND_NEWSLETTER:
      return (
        <SvgNewsLetterAndCommunity
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case FEATURE_NAME.SEARCH:
      return (
        <SvgSearchCollectionIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case FEATURE_NAME.COLLECTION:
      return (
        <SvgSearchCollectionIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case FEATURE_NAME.EMAIL_OUTREACH:
      return (
        <SvgEmailOutreachIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case FEATURE_NAME.DOMAINS:
      return (
        <SvgDomainIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case FEATURE_NAME.DEAL_TRACKER:
      return (
        <SvgDealTracker
          isHarbour={isHarbour}
          className="h-6 w-6 text-gray-600"
        />
      );
    case FEATURE_NAME.LETTER_OUTREACH:
      return (
        <SvgLetterOutreach
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case FEATURE_NAME.MAILBOXES:
      return (
        <SvgMailBoxIcon
          isHarbour={isHarbour}
          className="h-4 w-4 text-gray-600 mr-2"
        />
      );
    case FEATURE_NAME.UNLIMITED_SEARCH:
      return (
        <SvgSearchIcon
          className="h-6 w-6 text-gray-600"
          isHarbour={isHarbour}
        />
      );
    case FEATURE_NAME.SELLER_VERFIED_Listings:
      return (
        <SvgListCheckIcon
          className="h-6 w-6 text-gray-600"
          isHarbour={isHarbour}
        />
      );
    case FEATURE_NAME.TEAM_MEMBERS:
      return (
        <UsersRoundIcon
          stroke={isHarbour ? "#0BA5EC" : "#F63D68"}
          className="h-6 w-6 text-gray-600"
        />
      );
    default:
      return (
        <CheckIcon className="h-4 w-4 text-pink-500 mr-2 mt-0.5 flex-shrink-0" />
      );
  }
};

export const getPlanIcon = ({ planName, isHarbour }: PlanIconProps) => {
  return planName === SUBSCRIPTION_PLAN_NAME.BUY_SIDE_EMERGING ? (
    <SvgTelescopeIcon isHarbour={isHarbour} />
  ) : planName === SUBSCRIPTION_PLAN_NAME.BUY_SIDE_SEARCHER ? (
    <SvgSearchIconSubscription isHarbour={isHarbour} />
  ) : (
    <SvgTeamIconSubscription isHarbour={isHarbour} />
  );
};
